import React, { useMemo } from "react";

// Subtle drifting starfield + energy orbs. Fixed behind all content (z-0).
export default function CosmicBackground() {
  const stars = useMemo(
    () =>
      Array.from({ length: 46 }).map((_, i) => ({
        id: i,
        top: Math.random() * 100,
        left: Math.random() * 100,
        size: Math.random() * 2.4 + 0.6,
        delay: Math.random() * 6,
        dur: Math.random() * 5 + 4,
        dx: `${(Math.random() - 0.5) * 40}px`,
        dy: `${(Math.random() - 0.5) * 40}px`,
        gold: Math.random() > 0.7,
      })),
    []
  );

  return (
    <div className="fixed inset-0 z-0 overflow-hidden pointer-events-none" aria-hidden="true" data-testid="cosmic-bg">
      {/* Slow-drifting energy orbs */}
      <div
        className="absolute -top-32 -left-24 h-[38rem] w-[38rem] rounded-full blur-[120px] opacity-[0.16]"
        style={{ background: "radial-gradient(circle, #10B981, transparent 70%)", animation: "float-orb 26s ease-in-out infinite", ["--ox"]: "60px", ["--oy"]: "50px" }}
      />
      <div
        className="absolute bottom-0 left-1/3 h-[30rem] w-[30rem] rounded-full blur-[130px] opacity-[0.10]"
        style={{ background: "radial-gradient(circle, #D4AF37, transparent 70%)", animation: "float-orb 38s ease-in-out infinite", ["--ox"]: "40px", ["--oy"]: "-60px" }}
      />

      {/* Twinkling stars */}
      {stars.map((s) => (
        <span
          key={s.id}
          className="absolute rounded-full"
          style={{
            top: `${s.top}%`,
            left: `${s.left}%`,
            width: s.size,
            height: s.size,
            background: s.gold ? "#FDE68A" : "#E2E8F0",
            boxShadow: s.gold ? "0 0 6px #D4AF37" : "0 0 5px rgba(226,232,240,0.7)",
            animation: `twinkle ${s.dur}s ease-in-out ${s.delay}s infinite, drift ${s.dur * 3}s ease-in-out ${s.delay}s infinite`,
            ["--dx"]: s.dx,
            ["--dy"]: s.dy,
          }}
        />
      ))}
    </div>
  );
}
